var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { WidgetType } from '@common/api';
import { useAuth } from '../../../providers/AuthProvider';
import { useTagContext } from '@data/tag/tagContext';
import { getTagLongName } from '@data/tag/tagUtil';
import { useCloneWidget, useDeleteWidget } from '@data/widgets/widgetActions';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import WidgetMenu from '@main/dashboard/WidgetMenu';
import WidgetParentChangeModal from '@main/dashboard/WidgetParentChangeModal';
import { ArrowUp, Check, Close, Copy, Delete, Edit, Select } from '@shared/icons/icons';
import Manager from '@shared/modal/Manager';
import { TagSlicerButton, TagSlicerButtonTitle, WidgetBox, WidgetContent, WidgetTitle } from '@styled/Widget';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { isAccountTag, isDimensionTag, isTableTag } from '../../../data/tag/types';
import { handleApiErrorMessage } from '../../../util/message';
import TagSlicerEditor from './TagSlicerEditor';
import { FixedSizeGrid } from 'react-window';
import useDebouncedResizeObserver from '@hooks/useDebouncedResizeObserver';
import { engineApi } from '../../../data/rest/api';
import { getFilterCompoundExpression } from '../../../data/sheetRow/sheetRow';
function TagSlicer(_a) {
    var _this = this;
    var _b;
    var gridId = _a.gridId, widget = _a.widget, documentActions = _a.documentActions, saveSlicer = _a.saveSlicer, tagSlicersData = _a.tagSlicersData, tagSlicersTagIdsLocalChangesHandler = _a.tagSlicersTagIdsLocalChangesHandler;
    var user = useAuth().user;
    var L = useLanguage().L;
    var wrapperRef = useRef(null);
    var cloneWidget = useCloneWidget();
    var deleteWidget = useDeleteWidget();
    var tagData = useTagContext().tagData;
    var activeTagIds = tagSlicersData.activeTagIds, unfilteredAllTagIds = tagSlicersData.unfilteredAllTagIds, tagTableIdByWidgetId = tagSlicersData.tagTableIdByWidgetId; // data for all slicers in current report
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widget.config, WidgetType.TAGSLICER); }, [widget.config]);
    var _c = __read(useState((_b = activeTagIds[widget.id]) !== null && _b !== void 0 ? _b : []), 2), currActiveTagIds = _c[0], setCurrActiveTagIds = _c[1];
    var _d = __read(useState([]), 2), tagIdsWithData = _d[0], setTagIdsWithData = _d[1];
    var _e = __read(useState(''), 2), onlyWithDataKey = _e[0], setOnlyWithDataKey = _e[1];
    var _f = useDebouncedResizeObserver(500, true), widgetRef = _f.ref, width = _f.width, height = _f.height;
    useEffect(function () {
        var _a;
        var newActiveTagIds = (_a = activeTagIds[widget.id]) !== null && _a !== void 0 ? _a : [];
        if (JSON.stringify(newActiveTagIds) !== JSON.stringify(currActiveTagIds)) {
            setCurrActiveTagIds(newActiveTagIds);
        }
    }, [activeTagIds]);
    // get all tags used in this slicer
    var thisTagSlicerTagIds = useMemo(function () {
        return tagSlicersData.filteredAllTagIds[widget.id] || [];
    }, [tagSlicersData.filteredAllTagIds]);
    // all thisTagSlicerTagIds or filtered by tags from other slicers
    var tagIdsToShow = useMemo(function () {
        var e_1, _a, e_2, _b, e_3, _c;
        var _d;
        var thisTableTagId = tagTableIdByWidgetId[widget.id]; // it's always just one table per slcier
        var otherTableWithActiveTagIdsByWidgetId = new Map();
        try {
            for (var _e = __values(Object.keys(activeTagIds)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var key = _f.value;
                var widgetId = Number(key);
                if (widgetId === widget.id) {
                    continue;
                }
                var otherTagIds = activeTagIds[widgetId];
                if (otherTagIds === undefined || otherTagIds.length === 0) {
                    continue;
                }
                var otherTableTagIds = new Set();
                var tableId = tagTableIdByWidgetId[widgetId];
                if (tableId) {
                    otherTableTagIds.add(tableId);
                }
                otherTableWithActiveTagIdsByWidgetId.set(widgetId, otherTableTagIds);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // filter tags by other tag slicers
        var filteredTagIds = [];
        try {
            for (var thisTagSlicerTagIds_1 = __values(thisTagSlicerTagIds), thisTagSlicerTagIds_1_1 = thisTagSlicerTagIds_1.next(); !thisTagSlicerTagIds_1_1.done; thisTagSlicerTagIds_1_1 = thisTagSlicerTagIds_1.next()) {
                var tagId = thisTagSlicerTagIds_1_1.value;
                var show = [];
                var _loop_1 = function (key) {
                    var e_4, _j, e_5, _k, e_6, _l;
                    var widgetId = Number(key);
                    if (widgetId === widget.id) {
                        return "continue";
                    }
                    var otherTagIds = activeTagIds[widgetId];
                    if (widgetId.toString() === widget.id.toString() ||
                        otherTagIds === undefined ||
                        otherTagIds.length === 0) {
                        show.push(true);
                        return "continue";
                    }
                    var shouldAddTag = false;
                    var otherTableTagIds = otherTableWithActiveTagIdsByWidgetId.get(widgetId);
                    if (!otherTableTagIds) {
                        show.push(true);
                        return "continue";
                    }
                    var hasRelation = false;
                    try {
                        for (var otherTableTagIds_1 = (e_4 = void 0, __values(otherTableTagIds)), otherTableTagIds_1_1 = otherTableTagIds_1.next(); !otherTableTagIds_1_1.done; otherTableTagIds_1_1 = otherTableTagIds_1.next()) {
                            var oId = otherTableTagIds_1_1.value;
                            if (tagData.relationByKey.has("".concat(thisTableTagId, "-").concat(oId))) {
                                hasRelation = true;
                                break;
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (otherTableTagIds_1_1 && !otherTableTagIds_1_1.done && (_j = otherTableTagIds_1.return)) _j.call(otherTableTagIds_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    var hasIndirectRelation = false;
                    var checkForIndirectRelation = function (cId, tId) {
                        var connections = tagData.relationsByTableTagId[cId];
                        connections === null || connections === void 0 ? void 0 : connections.forEach(function (conn) {
                            if (conn.connectedTableTagId !== cId) {
                                if (tagData.relationByKey.has("".concat(conn.connectedTableTagId, "-").concat(tId))) {
                                    hasIndirectRelation = true;
                                }
                                checkForIndirectRelation(conn.connectedTableTagId, tId);
                            } // da ne pokusava filtrirat samu sebe (ako je self-connected table)
                        });
                    };
                    checkForIndirectRelation(thisTableTagId, tagTableIdByWidgetId[widgetId]);
                    try {
                        for (var otherTagIds_1 = (e_5 = void 0, __values(otherTagIds)), otherTagIds_1_1 = otherTagIds_1.next(); !otherTagIds_1_1.done; otherTagIds_1_1 = otherTagIds_1.next()) {
                            var otherTagId = otherTagIds_1_1.value;
                            var otherTagDownstreams = tagData.downstreamTagIds.get(otherTagId);
                            var currentTagDownstreams = tagData.downstreamTagIds.get(tagId);
                            if (otherTagDownstreams === null || otherTagDownstreams === void 0 ? void 0 : otherTagDownstreams.has(tagId)) {
                                shouldAddTag = true;
                                break;
                            }
                            if (currentTagDownstreams === null || currentTagDownstreams === void 0 ? void 0 : currentTagDownstreams.has(otherTagId)) {
                                shouldAddTag = true;
                                break;
                            }
                            if (hasRelation && !hasIndirectRelation) {
                                continue;
                            }
                            if (hasIndirectRelation) {
                                var currentTagParent = thisTableTagId;
                                var otherTagDownstreamContainsSiblings = false;
                                if (currentTagParent) {
                                    var currentTagSiblingsIds = (_d = unfilteredAllTagIds[widget.id]) !== null && _d !== void 0 ? _d : [];
                                    try {
                                        for (var currentTagSiblingsIds_1 = (e_6 = void 0, __values(currentTagSiblingsIds)), currentTagSiblingsIds_1_1 = currentTagSiblingsIds_1.next(); !currentTagSiblingsIds_1_1.done; currentTagSiblingsIds_1_1 = currentTagSiblingsIds_1.next()) {
                                            var ctsId = currentTagSiblingsIds_1_1.value;
                                            if (otherTagDownstreams === null || otherTagDownstreams === void 0 ? void 0 : otherTagDownstreams.has(ctsId)) {
                                                otherTagDownstreamContainsSiblings = true;
                                                break;
                                            }
                                        }
                                    }
                                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                    finally {
                                        try {
                                            if (currentTagSiblingsIds_1_1 && !currentTagSiblingsIds_1_1.done && (_l = currentTagSiblingsIds_1.return)) _l.call(currentTagSiblingsIds_1);
                                        }
                                        finally { if (e_6) throw e_6.error; }
                                    }
                                }
                                shouldAddTag = !otherTagDownstreamContainsSiblings;
                            }
                            else {
                                shouldAddTag = true;
                            }
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (otherTagIds_1_1 && !otherTagIds_1_1.done && (_k = otherTagIds_1.return)) _k.call(otherTagIds_1);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                    show.push(shouldAddTag);
                };
                try {
                    for (var _g = (e_3 = void 0, __values(Object.keys(activeTagIds))), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var key = _h.value;
                        _loop_1(key);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                if (!show.includes(false)) {
                    filteredTagIds.push(tagId);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (thisTagSlicerTagIds_1_1 && !thisTagSlicerTagIds_1_1.done && (_b = thisTagSlicerTagIds_1.return)) _b.call(thisTagSlicerTagIds_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return filteredTagIds;
    }, [thisTagSlicerTagIds, tagSlicersData]);
    var setAndSaveNewActiveTagIds = function (newActiveTagIds) { return __awaiter(_this, void 0, void 0, function () {
        var sameAsOriginal;
        return __generator(this, function (_a) {
            setCurrActiveTagIds(newActiveTagIds);
            sameAsOriginal = JSON.stringify(widgetConfig.tags) === JSON.stringify(newActiveTagIds);
            tagSlicersTagIdsLocalChangesHandler(widget.id, newActiveTagIds, sameAsOriginal);
            return [2 /*return*/];
        });
    }); };
    // update active tags ids if tags in other slicers have changed
    useEffect(function () {
        if (thisTagSlicerTagIds.length === 0) {
            // tags not loaded yet
            return;
        }
        var filtered = currActiveTagIds.filter(function (tId) { return tagIdsToShow.includes(tId); });
        if (JSON.stringify(filtered) !== JSON.stringify(currActiveTagIds)) {
            setAndSaveNewActiveTagIds(filtered);
        }
    }, [activeTagIds, tagIdsToShow]);
    // fetch new info for tags with data if only with data config has changed (or tags)
    useEffect(function () {
        var fetchTagIdsWithData = function () { return __awaiter(_this, void 0, void 0, function () {
            var tableTagIds, accountTagIds, tag, dimensionTagIds, newOnlyWithDataKey, usedTagIds, tableTagIds_1, tableTagIds_1_1, tableTagId, res, compoundExpression, error_1, e_7_1;
            var e_7, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tableTagIds = widgetConfig.tagSlicerTags.filter(function (tId) { return !!isTableTag(tagData.tagById[tId]); });
                        accountTagIds = [];
                        if (widgetConfig.onlyWithDataAccountId) {
                            tag = tagData.tagById[widgetConfig.onlyWithDataAccountId];
                            if (isAccountTag(tag)) {
                                accountTagIds.push(widgetConfig.onlyWithDataAccountId);
                            }
                        }
                        dimensionTagIds = widgetConfig.onlyWithDataDimensionIds.filter(function (tId) { return !!isDimensionTag(tagData.tagById[tId]); });
                        newOnlyWithDataKey = JSON.stringify({ tableTagIds: tableTagIds, accountTagIds: accountTagIds, dimensionTagIds: dimensionTagIds });
                        usedTagIds = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, 11, 12]);
                        tableTagIds_1 = __values(tableTagIds), tableTagIds_1_1 = tableTagIds_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!tableTagIds_1_1.done) return [3 /*break*/, 9];
                        tableTagId = tableTagIds_1_1.value;
                        res = void 0;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 7]);
                        compoundExpression = getFilterCompoundExpression(dimensionTagIds, tagData.tagById);
                        return [4 /*yield*/, engineApi.getDimensionTagsWithData({
                                accountTagIds: accountTagIds,
                                tableTagId: tableTagId,
                                compoundExpression: compoundExpression,
                            })];
                    case 4:
                        res = _b.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        error_1 = _b.sent();
                        return [4 /*yield*/, handleApiErrorMessage(error_1)];
                    case 6:
                        _b.sent();
                        return [2 /*return*/];
                    case 7:
                        if (res) {
                            usedTagIds.push.apply(usedTagIds, __spreadArray([], __read(res), false));
                        }
                        _b.label = 8;
                    case 8:
                        tableTagIds_1_1 = tableTagIds_1.next();
                        return [3 /*break*/, 2];
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_7_1 = _b.sent();
                        e_7 = { error: e_7_1 };
                        return [3 /*break*/, 12];
                    case 11:
                        try {
                            if (tableTagIds_1_1 && !tableTagIds_1_1.done && (_a = tableTagIds_1.return)) _a.call(tableTagIds_1);
                        }
                        finally { if (e_7) throw e_7.error; }
                        return [7 /*endfinally*/];
                    case 12:
                        setTagIdsWithData(usedTagIds);
                        setOnlyWithDataKey(newOnlyWithDataKey);
                        return [2 /*return*/];
                }
            });
        }); };
        if (widgetConfig.onlyWithDataAccountId) {
            fetchTagIdsWithData();
        }
    }, [
        widgetConfig.onlyWithDataAccountId,
        widgetConfig.onlyWithDataDimensionIds,
        widgetConfig.tagSlicerTags,
        onlyWithDataKey,
        tagData.tagById,
    ]);
    var toggleTag = function (tagId) { return __awaiter(_this, void 0, void 0, function () {
        var newActiveTags;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newActiveTags = __spreadArray([], __read(currActiveTagIds), false);
                    if (widgetConfig.multipleSelect) {
                        if (currActiveTagIds.includes(tagId)) {
                            newActiveTags = newActiveTags.filter(function (tId) { return tId !== tagId; });
                        }
                        else {
                            newActiveTags.push(tagId);
                        }
                    }
                    else {
                        if (newActiveTags.includes(tagId)) {
                            newActiveTags = [];
                        }
                        else {
                            newActiveTags = [tagId];
                        }
                    }
                    return [4 /*yield*/, setAndSaveNewActiveTagIds(newActiveTags)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var selectAll = function (value) {
        if (value) {
            setAndSaveNewActiveTagIds(tagsToShow.map(function (tag) { return tag.id; }));
        }
        else {
            setAndSaveNewActiveTagIds([]);
        }
    };
    // fetch tag data (and filter onlyWithData if needed)
    var tagsToShow = useMemo(function () {
        var e_8, _a, e_9, _b;
        var arr = [];
        if (widgetConfig.onlyWithDataAccountId) {
            try {
                for (var tagIdsToShow_1 = __values(tagIdsToShow), tagIdsToShow_1_1 = tagIdsToShow_1.next(); !tagIdsToShow_1_1.done; tagIdsToShow_1_1 = tagIdsToShow_1.next()) {
                    var tId = tagIdsToShow_1_1.value;
                    if (tagIdsWithData.includes(tId) && tagData.tagById[tId] !== undefined) {
                        arr.push(tagData.tagById[tId]);
                    }
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (tagIdsToShow_1_1 && !tagIdsToShow_1_1.done && (_a = tagIdsToShow_1.return)) _a.call(tagIdsToShow_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
        else {
            try {
                for (var tagIdsToShow_2 = __values(tagIdsToShow), tagIdsToShow_2_1 = tagIdsToShow_2.next(); !tagIdsToShow_2_1.done; tagIdsToShow_2_1 = tagIdsToShow_2.next()) {
                    var tId = tagIdsToShow_2_1.value;
                    if (tagData.tagById[tId] !== undefined) {
                        arr.push(tagData.tagById[tId]);
                    }
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (tagIdsToShow_2_1 && !tagIdsToShow_2_1.done && (_b = tagIdsToShow_2.return)) _b.call(tagIdsToShow_2);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        return arr;
    }, [tagData.tagById, tagIdsToShow, tagIdsWithData, widgetConfig.onlyWithDataAccountId]);
    var selectMenuItemsAndSpace = [{ spacer: true }];
    if (widgetConfig.multipleSelect) {
        selectMenuItemsAndSpace.push({
            icon: Check,
            actionName: L('Select All'),
            action: function () { return selectAll(true); },
        }, {
            icon: Close,
            actionName: L('Unselect All'),
            action: function () { return selectAll(false); },
        }, { spacer: true });
    }
    var widgetMenuItems = __spreadArray(__spreadArray([
        {
            icon: Edit,
            actionName: L('Edit Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(TagSlicerEditor, { widget: widget, gridId: gridId })); },
        },
        {
            icon: Copy,
            actionName: L('Duplicate'),
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canDuplicate),
            action: function () { return cloneWidget.mutate(widget); },
        },
        {
            icon: Select,
            actionName: L('Move to'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(WidgetParentChangeModal, { widget: widget, gridId: gridId })); },
        }
    ], __read(selectMenuItemsAndSpace), false), [
        {
            icon: ArrowUp,
            actionName: L('Save for everyone'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return saveSlicer(widget.id); },
        },
        { spacer: true },
        {
            icon: Delete,
            actionName: L('Delete Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canDelete),
            action: function () { return deleteWidget.mutate(widget.id); },
            destructive: true,
        },
    ], false);
    var space = 5;
    var _g = __read(useMemo(function () {
        var cw = 126;
        var rh = 30;
        var cc = width ? Math.floor(width / cw) : 1;
        if (cc === 0) {
            cc = 1;
        }
        var rc = cc > 1 ? Math.ceil(tagsToShow.length / cc) : tagsToShow.length;
        return [cw, cc, rh, rc];
    }, [width, height, tagsToShow.length]), 4), colWidth = _g[0], colCount = _g[1], rowHeight = _g[2], rowCount = _g[3];
    function TagItem(_a) {
        var columnIndex = _a.columnIndex, rowIndex = _a.rowIndex, style = _a.style;
        var index = rowIndex * colCount + columnIndex;
        var tag = tagsToShow[index];
        if (!tag) {
            return null;
        }
        return (React.createElement("div", { style: style },
            React.createElement(TagSlicerButton, { key: tag.id, "$active": currActiveTagIds.includes(tag.id), onClick: function () { return toggleTag(tag.id); }, onMouseDown: function (e) { return e.stopPropagation(); }, style: { width: colWidth - space, minHeight: rowHeight - space } },
                React.createElement(TagSlicerButtonTitle, null, getTagLongName(tag, widgetConfig.tagNameDisplay)))));
    }
    return (React.createElement(WidgetBox, { ref: wrapperRef, key: "".concat(width, "-").concat(height) },
        widget.title && widget.title !== '' && React.createElement(WidgetTitle, null, widget.title),
        React.createElement(WidgetMenu, { wrapperRef: wrapperRef, menuItems: widgetMenuItems }),
        React.createElement(WidgetContent, { ref: widgetRef, "$overflow": "hidden" },
            React.createElement(FixedSizeGrid, { height: height || 0, width: width || 0, columnCount: colCount, columnWidth: colWidth, rowCount: rowCount, rowHeight: rowHeight, style: {
                    position: 'relative',
                } }, TagItem))));
}
export default TagSlicer;
